module.exports = __webpack_public_path__ + "img/center.fa6602d1.svg";